import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';
import type { Dayjs } from 'dayjs';
import type { LeaveRequest } from '~weekly-planner/lib/common';

export const selectUsersRows = (state: RootState) => state.weeklyPlanner.users.rows;

export const selectWorkerLeaveStatus = createSelector(
  [
    selectUsersRows,
    (_: RootState, userId: number | string) => userId,
    (___: RootState, __: number | string, date: string | Dayjs) => date,
  ],
  (rows, userId, date) => {
    const userIdStr = userId.toString();
    const userRow = rows.find((row) => row.id.toString() === userIdStr);
    if (!userRow || !userRow.leave_requests || userRow.leave_requests.length === 0) return false;

    const targetDate = typeof date === 'string' ? date : date.format('YYYY-MM-DD');
    return userRow.leave_requests.some((request: LeaveRequest) => {
      const start = request.date_start;
      const end = request.date_end ?? start;
      return start <= targetDate && end >= targetDate;
    });
  },
);
